import { render } from "./ProjectItem.vue?vue&type=template&id=31fda726&ts=true"
import script from "./ProjectItem.vue?vue&type=script&lang=ts"
export * from "./ProjectItem.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.34_vue@3.5.34_typescript@5.9.3__webpack@5.107.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__